import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LinkIconFor } from "@/components/LinkIcon";
import { trackClick } from "@/lib/api";
import { rise } from "@/lib/motion";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const LinkButton = ({ link }) => {
  const primary = link.variant === "primary";

  return (
    <motion.a
      variants={rise}
      whileHover={{ scale: 1.015 }}
      whileTap={{ scale: 0.985 }}
      transition={{ type: "spring", stiffness: 420, damping: 30 }}
      href={link.url}
      onClick={() => trackClick(link.id)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={primary ? "primary-cta-button" : `link-button-${slug(link.title)}`}
      className={[
        "group flex w-full items-center gap-3 h-[54px] sm:h-[56px] min-h-[44px] px-4 rounded-[14px] card-shadow",
        "transition-colors duration-200 outline-none focus-visible:ring-2 focus-visible:ring-[#111]/20",
        primary
          ? "bg-[var(--accent)] text-white hover:bg-[var(--accent-hover)]"
          : "bg-white text-[#111] border border-[#EAEAEA] hover:border-[#D6D6D6]",
      ].join(" ")}
    >
      <span
        className={[
          "flex h-9 w-9 shrink-0 items-center justify-center rounded-full",
          primary ? "bg-white/15" : "bg-[#FAFAFA]",
        ].join(" ")}
      >
        <LinkIconFor name={link.icon} className="h-[18px] w-[18px]" />
      </span>

      <span className="flex min-w-0 flex-1 flex-col text-left leading-tight">
        <span className="text-[15px] font-semibold truncate">{link.title}</span>
        {link.subtitle && (
          <span className={["text-xs truncate", primary ? "text-white/80" : "text-[#666]"].join(" ")}>
            {link.subtitle}
          </span>
        )}
      </span>

      <ArrowUpRight
        strokeWidth={1.75}
        className={[
          "h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5",
          primary ? "text-white/80" : "text-[#999]",
        ].join(" ")}
        aria-hidden="true"
      />
    </motion.a>
  );
};
